import { render, staticRenderFns } from "./Lyrics.vue?vue&type=template&id=3d2e5f76"
import script from "./Lyrics.vue?vue&type=script&lang=js"
export * from "./Lyrics.vue?vue&type=script&lang=js"
import style0 from "./Lyrics.vue?vue&type=style&index=0&id=3d2e5f76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports